/**
 * Appointment Service (Frontend)
 *
 * Wiederverwendbarer Service für Termin-API-Aufrufe.
 * Wird vom Dashboard und der Terminseite genutzt.
 */

import apiClient from '../api/apiClient';
import { Appointment, AppointmentType } from '../../components/appointments/appointment.types';

// ============================================
// SERVICE FUNCTIONS
// ============================================

/**
 * Termine des Benutzers abrufen
 * @param filter - 'all' = alle (inkl. vergangene), 'upcoming' = nur kommende
 */
export const getUserAppointments = async (filter: 'all' | 'upcoming' = 'all'): Promise<Appointment[]> => {
  const response = await apiClient.get(`/appointments/user/upcoming?filter=${filter}`);
  return response.data.appointments || [];
};

/**
 * Vergangene Termine abrufen
 */
export const getAppointmentHistory = async (): Promise<Appointment[]> => {
  const response = await apiClient.get('/appointments/user/history');
  return response.data.appointments || [];
};

/**
 * Alle verfügbaren Termintypen abrufen
 */
export const getAppointmentTypes = async (): Promise<AppointmentType[]> => {
  const response = await apiClient.get('/appointments/types');
  return response.data.types || [];
};

/**
 * Einzelnen Termin abrufen
 */
export const getAppointmentById = async (id: string): Promise<Appointment> => {
  const response = await apiClient.get(`/appointments/user/${id}`);
  return response.data.appointment;
};

/**
 * Termin stornieren
 */
export const cancelAppointment = async (id: string, reason?: string): Promise<void> => {
  await apiClient.post(`/appointments/${id}/cancel`, { reason });
};

/**
 * Reservierung bestätigen (für kostenlose Termine)
 */
export const confirmReservation = async (id: string): Promise<void> => {
  await apiClient.put(`/appointments/${id}/confirm`);
};

export default {
  getUserAppointments,
  getAppointmentHistory,
  getAppointmentTypes,
  getAppointmentById,
  cancelAppointment,
  confirmReservation,
};
